import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';

@Component({
  selector: 'app-email-verify-success',
  standalone: true,
  imports: [CommonModule],
  template: `
  <div class="verify-wrap">
    <div class="card">
      <div class="card-header">
        <div class="icon-check">✓</div>
        <h2 class="title">¡Email validado!</h2>
      </div>
      <p class="desc">La cuenta del administrador ha sido validada correctamente.</p>

      <div class="success">
        <p>Correo confirmado: <strong><code>{{ email || '—' }}</code></strong>.</p>
        <p class="hint">Ahora puedes iniciar sesión con tus credenciales.</p>
        <div class="actions">
          <button class="btn primary" (click)="goToLogin()">Volver al login</button>
          <a class="btn" href="/">Ir al inicio</a>
        </div>
      </div>
    </div>
  </div>
  `,
  styles: [
    `
    .verify-wrap{display:flex;align-items:center;justify-content:center;min-height:70vh;padding:24px}
    .card{max-width:780px;width:100%;background:#fff;border-radius:12px;box-shadow:0 6px 16px rgba(0,0,0,.08);padding:24px}
    .card-header{display:flex;align-items:center;gap:12px;margin-bottom:8px}
    .icon-check{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border-radius:9999px;background:#22c55e;color:#fff;font-weight:700}
    .title{margin:0;font-size:22px;font-weight:600;color:#111827}
    .desc{margin:0 16px 16px 0;color:#6b7280;font-size:14px}
    .success{margin-top:8px;color:#065f46;background:#d1fae5;border:1px solid #a7f3d0;padding:10px;border-radius:8px}
    .hint{color:#065f46}
    .actions{margin-top:16px;display:flex;gap:12px}
    .btn{appearance:none;border:none;border-radius:8px;padding:10px 16px;background:#f3f4f6;color:#111827;font-weight:500;cursor:pointer;text-decoration:none}
    .btn.primary{background:#f26600;color:#fff}
    .btn:hover{filter:brightness(.98)}
    code{background:#f3f4f6;padding:0 4px;border-radius:4px}
    `
  ]
})
export class EmailVerifySuccessComponent {
    email = '';

    constructor(private route: ActivatedRoute) {
        const qp = this.route.snapshot.queryParamMap;
        this.email = (qp.get('email') || '').toString();
    }

    goToLogin() {
        window.location.href = '/login';
    }
}